import axios, { AxiosRequestConfig } from 'axios';
import UserManager, { UserCentralContext } from '../../application/common/usermanagement';

// eslint-disable-next-line
export const AxiosInterceptors = (function() {

    const injectAxiosInterceptors = function() {

        axios.interceptors.request.use(async request => {
            if(!(await validateRequestAuthAsync(request))) {
                window.location.reload();
                return null;
            }
            request.headers.common['Authorization'] = UserCentralContext?.UserCentralToken?.TokenKey;
            return request;
        }, error => {
            console.log(error);
            return Promise.reject(error);
        });

        axios.interceptors.request.use(request => {
            if(!(validateRequestAuth(request))) {
                window.location.reload();
                return null;
            }
            request.headers.common['Authorization'] = UserCentralContext?.UserCentralToken?.TokenKey;
            return request;
        }, error => {
            console.log(error);
            return Promise.reject(error);
        });
    };

    const validateRequestAuthAsync = async function(request: AxiosRequestConfig) {
        if (request?.url?.includes('/system/CAS/')) {       
            return true;       
        }
        return await UserManager.checkTokenAndRefresh();
    }

    const validateRequestAuth = function(request: AxiosRequestConfig) {
        if (request?.url?.includes('/system/CAS/')) {     
            return true;       
        }
        return UserManager.checkToken();
    }

    return {
        injectAxiosInterceptors: injectAxiosInterceptors
    }

})();

export default AxiosInterceptors;
